package app.smartcoding.realrate.domain.tools

// Helper to get double value or 0.0
fun String.toDoubleOrZero(): Double = toDoubleOrNull() ?: 0.0